<template>
  <div id="add-candidate-form">
    <section>
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="row">
            <div class="form-group filter-item m-label col-md-12 required">
              <v-select
                v-model="selectedEmployer"
                @input="handleEmployersSelect"
                :options="getEmployersDropdown"
                :disabled="isLoading"
                inputId="add-to-pipeline-select"
                label="name"
                :reduce="employer => employer"
                :clearable="false"
                id="employer"
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Sorry, no matching employer</div>
                </template>
              </v-select>
              <label for="employer">Employer</label>
            </div>

            <div class="form-group filter-item m-label col-md-12 required">
              <v-select
                v-model="selectedJob"
                :options="getJobsForEmployer.filter(job => job.status !== 4 && job.status !== 5)"
                :clearable="false"
                :disabled="isLoading"
                label="title"
                id="job"
                :reduce="job => job"
              >
                <template slot="option" slot-scope="option">
                  {{ option.title }},
                  {{ option.city.name }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.title }},
                  {{ option.city.name }}
                </template>
              </v-select>
              <label for="job">Job</label>
            </div>

            <div class="form-group col-md-12 m-label required">
              <select
                style="padding-left: 18px"
                v-model="selectedSource"
                class="form-select"
                id="source-pipeline-modal"
              >
                <option v-for="source in getSourceList" :key="source.id" :value="source">
                  {{ source.description }} ({{ source.source_name }})
                </option>
              </select>
              <label for="source">Source</label>
            </div>

            <div class="form-group m-label col-md-12 required">
              <textarea
                v-model="activity_comment"
                class="form-control"
                style="min-height: 3rem"
                id="internal-note-textarea"
                rows="1"
                :disabled="isLoading"
                itemid="note"
              ></textarea>
              <label for="internal-note-textarea">Activity comment</label>
            </div>

            <!--  <div class="custom-control custom-checkbox ml-3 mb-3">
              <input
                id="submit-to-employer-checkbox"
                class="mr-2 custom-control-input"
                type="checkbox"
                v-model="submitToEmployer"
                @change="handleChange"
                :disabled="isLoading"
                aria-label
              />
              <label class="custom-control-label" for="submit-to-employer-checkbox">
                {{ 'Submit to Employer' }}
              </label>
            </div> -->

            <!-- Options: Not contacted, Contacted, Interviewing, No longer interested, Not in consideration -->
            <div class="form-group m-label col-md-12 required mt-2">
              <select
                class="form-control"
                v-model="selectedQualification"
                :disabled="isLoading"
                id="qualification"
              >
                <option value="not_contacted">Not contacted</option>
                <option value="contacted">Contacted</option>
                <option value="responded">Responded</option>
                <option value="interviewing">Interviewing</option>
                <option value="no_longer_interested">No longer interested</option>
                <option value="not_in_consideration">Not in consideration</option>
              </select>
              <label for="qualification">Qualification</label>
            </div>

            <!--  <div class="form-group m-label col-md-12 required">
              <textarea
                class="form-control"
                style="min-height: 3rem"
                id="note-to-employer"
                rows="1"
                v-model="noteToEmployer"
                :disabled="submitToEmployer == false"
              ></textarea>
              <label for="note-to-employer">Note to Employer</label>
            </div> -->

            <div class="form-group">
              <ul class="list-group file-listing mt-3">
                <li
                  :key="file.id"
                  v-for="file in getCandidateById.documents"
                  class="list-group-item d-flex align-items-center small"
                >
                  <div class="custom-control custom-checkbox d-flex">
                    <input
                      :id="`pipeline-${file.id}`"
                      class="custom-control-input"
                      type="checkbox"
                      v-model="selectedDocuments"
                      @change="handleCheckboxChange"
                      :value="file.id"
                      :disabled="isLoading"
                      aria-label
                    />
                    <label class="custom-control-label" :for="`pipeline-${file.id}`">
                      {{ file.name }}
                    </label>
                  </div>

                  <!--  <span class="badge badge-primary badge-pill ml-auto">{{
                    `${(file.file_size ? file.file_size / 1024 / 1024 : '').toFixed(2)} MB`
                  }}</span> -->
                </li>
              </ul>
            </div>
          </div>

          <!-- Nav btn's -->
          <div class="row justify-content-center mb-5 mt-4">
            <div class="col-6 text-center">
              <button
                @click="addCandidateToPipeline"
                form="add-for-job"
                class="btn btn-success btn-custom w-50 mr-2"
              >
                Add
              </button>
            </div>
            <div class="col-6 text-center">
              <!-- <div class="text-center mt-3 d-flex"> -->

              <button class="btn btn-primary btn-custom w-50 mr-5 prev" @click="$emit('close')">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="spinner-container" v-if="isLoading">
      <div class="spinner-grow" style="width: 3rem; height: 3rem" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow" style="width: 3rem; height: 3rem" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow" style="width: 3rem; height: 3rem" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <span>Loading...</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { errorService } from '../../../services/errorService';

export default {
  data: () => ({
    submitToEmployer: false,
    selectedQualification: 'not_contacted',
    isLoading: false,
    /* uuid for HH */
    selectedSource: {},
    selectedEmployer: '',
    selectedJob: '',
    activity_comment: '',
    noteToEmployer: '',
    selectedDocuments: [],
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveJobsForEmployerDropdown',
      'retrieveSourcesList',
      'submitCandidateToPipeline',
    ]),
    getDocumentProperties(fileName) {
      const re = /(?:\.([^.]+))?$/;

      if (re.exec(fileName)[1] === 'pdf') {
        return {
          color: '#ff0000',
          type: 'pdf',
        };
      } else if (re.exec(fileName)[1] === 'docx' || re.exec(fileName)[1] === 'doc') {
        return {
          color: '#005a9e',
          type: 'doc',
        };
      } else {
        return { color: '#a7a7a77', type: '' };
      }
    },
    handleCheckboxChange() {},
    addCandidateToPipeline() {
      this.isLoading = true;
      this.submitCandidateToPipeline({
        candidate_id: this.$route.params.candidate_id,
        js_employer_id: this.selectedEmployer.id,
        js_employer_jobad_id: this.selectedJob.id,
        source_id: this.selectedSource.id,
        activity_comment: this.activity_comment,
        qualification: this.selectedQualification,
        documents: this.selectedDocuments,
      })
        .then(() => {
          this.isLoading = false;

          this.$toasted.show('Candidate Added to Pipeline', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });

          this.$emit('pipeline-reload', { currentPage: this.getCurrentPage, count: 10 });
          this.$emit('close');

          this.clearForm();
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    /* handleChange() {
      if (this.submitToEmployer) {
        this.selectedQualification = 'submitted';
      } else {
        this.selectedQualification = '';
      }
    }, */
    handleEmployersSelect(selectedEmployer) {
      this.selectedJob = '';
      this.retrieveJobsForEmployerDropdown({ employerId: selectedEmployer.id });
    },
    clearForm() {
      this.selectedEmployer = '';
      this.selectedJob = '';
      this.selectedSource = {};
      this.activity_comment = '';
      this.selectedQualification = 'not_contacted';
    },
  },
  computed: {
    ...mapGetters([
      'getEmployersDropdown',
      'getJobsForEmployer',
      'getSourceList',
      'getCandidateById',
      'getCurrentPage',
    ]),
  },
  mounted() {
    this.retrieveEmployersDropdown();
    this.retrieveSourcesList();
  },
};
</script>

<style lang="scss" scoped>
.custom-control-label {
  vertical-align: middle;
  font-size: 14px;
  padding-top: 1px;
}

.form-floating {
  label {
    left: 12px !important;
  }
}
</style>
